module.exports = __webpack_public_path__ + "img/Intelligent_jgt.f6f67e07.png";